import type { FaireProductEntity } from "../../entity_types/product";

export const p_63en8h4gdu: FaireProductEntity = {
  token: "p_63en8h4gdu",
  type: "product",
  name: "Retro Oval Dial Gold Stainless Steel Watch DP25E446",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/ee83ba8d025ae349762604beba990c915c98c7baa4d108267cd153f6c640591d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1dc649589ac4d03275eab8c5f57d997037800f6aa1352b5b93fe4e4346f66a91.jpeg",
    "https://cdn.faire.com/fastly/1e63364cde3da80c3fb9fef9e03fba485ede704b2e9ede66915892153fb7e96a.jpeg",
    "https://cdn.faire.com/fastly/24162ec3a0d607180a1ccb6917364039dda0ea63bfafae96edde0808668f3617.jpeg",
    "https://cdn.faire.com/fastly/bd616dc335d3561d0c1ab3ba5fc2632bb05ea3f2a85fe001acaec5c02afe9e01.jpeg",
    "https://cdn.faire.com/fastly/0b84bbc134fd1a3d20eadc56c16590f1e0274a87972f59b636b7564cb10a0a57.jpeg",
    "https://cdn.faire.com/fastly/2e80315a31da625a2cbf98b9a0a75c023edb00588cefe61a50e1746445ed32dd.jpeg",
    "https://cdn.faire.com/fastly/94e79a206fe375b25e3b569e361c6263a1559c0bf78335742cabd855fab17c69.jpeg",
  ],
  priceDollars: 25.34,
  description:
    "Feature:\n * Minimalist, Vintage\n * Oval Dail\n * Elegant Design\n * Precise Movement\n * No Water Resistant\n * Adjustable Bracelet\n * Gift\n * Daily Fitting\n * Casual Style\n\n Material:\n * Stainless Steel\n\n Weigh: *40g\n\n Package:\n * Package include 1 watch.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 50.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:13.392Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
